import React from 'react';
import {
  Home,
  BarChart3,
  Users,
  Building2,
  ClipboardList,
  Calendar,
  Lightbulb,
  CheckCircle2,
  XCircle,
  Star as StarIconLucide,
  LogOut,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Eye,
  Pencil,
  Info,
  Award,
  TrendingUp,
  Target,
  Globe2,
  Ship,
  AlertTriangle,
  Anchor,
  Leaf,
  Apple,
  Fish,
  Package,
  Map as MapLucide,
  MapPin,
  Landmark,
  Mail,
  Phone,
  BadgeCheck,
  Angry,
  Frown,
  Meh,
  Smile,
  SmilePlus,
  Search,
  Menu,
  X,
  Bell,
} from 'lucide-react';

const iconFactory = (IconComponent, defaultClass = 'h-6 w-6') => ({ className, ...props } = {}) => (
  <IconComponent className={className || defaultClass} strokeWidth={1.8} {...props} />
);

export const HomeIcon = iconFactory(Home);
export const ChartBarIcon = iconFactory(BarChart3);
export const UsersIcon = iconFactory(Users);
export const BuildingOfficeIcon = iconFactory(Building2);
export const ClipboardListIcon = iconFactory(ClipboardList);
export const CalendarIcon = iconFactory(Calendar);
export const LightBulbIcon = iconFactory(Lightbulb);
export const CheckCircleIcon = iconFactory(CheckCircle2);
export const XCircleIcon = iconFactory(XCircle);
export const LogoutIcon = iconFactory(LogOut);
export const ChevronLeftIcon = iconFactory(ChevronLeft, 'h-5 w-5');
export const ChevronRightIcon = iconFactory(ChevronRight, 'h-5 w-5');
export const ChevronDownIcon = iconFactory(ChevronDown, 'h-5 w-5');
export const EyeIcon = iconFactory(Eye, 'h-5 w-5');
export const PencilIcon = iconFactory(Pencil);
export const InfoIcon = iconFactory(Info);

export const StarIcon = ({ solid = false, className = 'h-6 w-6', ...props }) => (
  <StarIconLucide className={`${className} ${solid ? 'fill-amber-400 text-amber-400' : ''}`} strokeWidth={solid ? 0 : 1.8} {...props} />
);

export const AwardIcon = iconFactory(Award);
export const TrendingUpIcon = iconFactory(TrendingUp);
export const TargetIcon = iconFactory(Target);
export const GlobeIcon = iconFactory(Globe2);
export const ShipIcon = iconFactory(Ship);
export const AlertIcon = iconFactory(AlertTriangle);
export const AnchorIcon = iconFactory(Anchor);
export const LeafIcon = iconFactory(Leaf);
export const AppleIcon = iconFactory(Apple);
export const FishIcon = iconFactory(Fish);
export const PackageIcon = iconFactory(Package);
export const MapIcon = iconFactory(MapLucide);
export const MapPinIcon = iconFactory(MapPin);
export const LandmarkIcon = iconFactory(Landmark);
export const MailIcon = iconFactory(Mail);
export const PhoneIcon = iconFactory(Phone);
export const BadgeIcon = iconFactory(BadgeCheck);
export const AngryFaceIcon = iconFactory(Angry);
export const FrownFaceIcon = iconFactory(Frown);
export const MehFaceIcon = iconFactory(Meh);
export const SmileFaceIcon = iconFactory(Smile);
export const GrinFaceIcon = iconFactory(SmilePlus);
export const MagnifyingGlassIcon = iconFactory(Search, 'h-5 w-5');
export const MenuIcon = iconFactory(Menu, 'h-5 w-5');
export const CloseIcon = iconFactory(X, 'h-5 w-5');
export const BellIcon = iconFactory(Bell, 'h-5 w-5');
